// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"IngredientsPop_ConfirmationPop__skB3q","modalBody":"IngredientsPop_modalBody__jKqZO"};